const sliderContextKey = Symbol("sliderContextKey");

export { sliderContextKey };
//# sourceMappingURL=constants.mjs.map
